import React from 'react'
import { MetersList } from '../../company/components/MetersList'

const CompanyMeters = ({ companyId }: { companyId: number }) => {
  return <MetersList companyId={companyId} location='overview' />
}

export default CompanyMeters
